function EmptyState({ text }) {
  return <div className="center muted">{text}</div>;
}

export default EmptyState;
